import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { RolePositionContent } from "PFApp/components/card_tx/content/role_position_content";
import { RolePositionFooter } from "PFApp/components/card_tx/footer/role_position_footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type AuditRoleVariantProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "isDraft" | "isHotVisible" | "interestedIn" | "handleShare"
>;

export const AuditRoleVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  isHotVisible,
  interestedIn,
  handleShare
}: AuditRoleVariantProps) => (
  <>
    <Header activity={activity} type={type} isFeed={isFeed} onShare={handleShare} />
    <Status isPrivate={activity.private} isDraft={isDraft} />
    <RolePositionContent activity={activity} isFeed={isFeed} />
    <RolePositionFooter isHotVisible={isHotVisible} interestedIn={interestedIn} />
  </>
);
